/* Generated by scripts/apply-brand.js — do not edit by hand */
export const brand = {
  id: "gpqbank",
  displayName: "GPQBank",
  appUrl: "https://app.gpqbank.com",
  marketingUrl: "https://gpqbank.com",
  contactEmail: "contact@gpqbank.com",
  metaDescription: "MSRA and MRCGP AKT question banks for GP trainees—clinical MCQs, SJTs, and AKT-style practice.",
  s3Bucket: "app.gpqbank.com",
  productIds: ["msra","mrcgp_akt"],
  colors: {
    primary: "#8b1e1e",
    primaryHover: "#6b1515",
    navy: "#3d0e0e",
    navyDeep: "#2a0808",
    navyMid: "#5c1212",
    accent: "#9b2424",
    accentAlt: "#a82828",
    stats: "#8b1e1e",
    statsHover: "#5c1212",
    footer: "#3d0e0e",
    footerDeep: "#2a0808",
    footerLight: "#5c1212",
    footerMuted: "#1a0505",
  },
} as const;

export type Brand = typeof brand;
